import {createActions} from 'client/framework';

const normalActions = ['HIDE_MODAL', 'SHOW_MODAL'];

const windowConfirmActions = createActions(null, normalActions);
export default windowConfirmActions;
